import * as React from "react";
import styles from "./Navbar.module.css";

export interface NavItemProps {
  label: string;
  href?: string;
  hasDropdown?: boolean;
  isActive?: boolean;
  onToggleDropdown?: () => void;
  isDropdownOpen?: boolean;
}

export const NavItem: React.FC<NavItemProps> = ({
  label,
  href,
  hasDropdown = false,
  isActive: _isActive = false,
  onToggleDropdown,
  isDropdownOpen: _isDropdownOpen = false,
}) => {
  const itemClassName = styles.navItem;

  if (hasDropdown) {
    return (
      <button
        className={itemClassName}
        type="button"
        onMouseEnter={onToggleDropdown}
      >
        <span>{label}</span>
      </button>
    );
  }

  return (
    <a href={href} className={itemClassName}>
      {label}
    </a>
  );
};
